<template>
  <div>
    <div v-if="customEmployeeList.length > 0">
      <div class="card-header px-0 bg-transparent border-0">
        <div class="row no-margin">
          <div class="pl-0 mr-4">
            <b-card-group deck>
              <b-card header="Cost Mapping" align="start">
                <b-button @click="exportCostSelected">
                  <b-icon icon="code-slash"></b-icon>
                  Template
                </b-button>
                <b-button @click="openUploadModal">
                  <b-icon icon="box-arrow-up" class="" scale="1"></b-icon>
                  Import
                </b-button>
                <b-button @click="downloadSelected">
                  <b-icon icon="box-arrow-down" class="" scale="1"></b-icon>
                  Download Letters
                </b-button>
                <b-button @click="mailSelected">
                  <b-icon icon="envelope" class="" scale="1"></b-icon>
                  <!-- Mail Report -->
                  Email Letters <!-- Rejwan: 06-02-2025 -->
                </b-button>
              </b-card>
            </b-card-group>
          </div>

          <div class="ml-auto">
            <b-card-group deck>
              <b-card header="Year" align="start">
                <b-input-group class="">
                  <b-input-group-prepend is-text>
                    Year
                  </b-input-group-prepend>
                  <b-form-select id="year" name="year" v-model="current_year" :options="years"
                    @change="setYear()"></b-form-select>
                </b-input-group>
              </b-card>
            </b-card-group>
          </div>
        </div>
      </div>
    </div>
    <div class="" v-if="selected.length > 0">Selected Employee(s): {{selected.length}}</div>

    <common-list :pageurl="this.$api_url" :is_action="is_action" :checkbox="1" :appended_column="appended_column"
      :key="list_key" :company_options="company_options" :employees="employees" :default_column="default_column"
      :primary_key="primary_key" :all_employee="all_employee" v-on:childToParent="listReturn"></common-list>

    <!-- Employee Policy Mapping Modal -->
    <b-modal id="bv-modal-employee-cost-mapping" size="lg" hide-footer :title="'Data of ' + employee_name + ' for ' + current_year"> <!-- Rejwan: 06-02-2025 -->
      <cost-mapping :employeeID="employeeID" :year="current_year" :type="type"
        @close-cost-mapping-modal="closeCostMappingModal"></cost-mapping>
    </b-modal> 

    <b-modal id="bv-modal-file-upload" size="sm" hide-footer title="Upload File">
      <b-form @submit.stop.prevent="importData">
        <b-form-file v-model="file" ref="file" :state="Boolean(file)"
                     @change="checkFileType($event , 'file' , ['.xlsx'])"
          placeholder="Choose a file..." drop-placeholder="Drop file..."></b-form-file>

        <b-button type="submit" class="mt-4">
          Upload
        </b-button>

      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { value } from "lodash/seq";
import { defaultsDeep } from "lodash/object";

export default {
  props: ['type'],
  data() {

    const now = new Date()
    return {
      ce: false,
      
      /**Child Component property data */
      checkbox: 1,
      is_action: 1,
      list_key: 0,
      employees: [],
      default_column: ['name', 'employee_code', 'jobposition', 'department'],
      primary_key: 'employee_id',
      company_options: [],
      appended_column: [],
      all_employee: 'yes',
      /***Child Component property data */

      selected: [], /** selected employee data */
      showOverlay: true,
      viewMode: true,
      notice: "Looks like you have not added any employee yet.",
      fdata: {},


      branches: [],
      departments: [],
      jobpositions: [],
      company_name: '',
      employee_name: '', // Rejwan: 06-02-2025

      emailing_class: '',

      customEmployeeList: [],

      employeeID: null,
      file: null,
      overHeadFile: null,


      years: [
        { text: '2022', value: '2022' },
        { text: '2023', value: '2023' },
        { text: '2024', value: '2024' },
        { text: '2025', value: '2025' },
        { text: '2026', value: '2026' },
      ],

      current_year: now.getFullYear(),

    }
  },
  methods: {
    setYear: function () {
      this.getEmployees();
    },
    refreshList() {
      if (!this.checkNet()) return false;
      this.getEmployees();
    },
    getEmployees: function () {
      if (!this.checkNet()) return false;
      this.showOverlay = true;
      let currentObj = this;

      axios.get(this.$api_url + '/cost-employee/list?year=' + this.current_year + '&type=' + this.type)
        .then(function (response) {
          currentObj.showOverlay = false;
          if (parseInt(response.data.error) === 1)
            currentObj.notice = response.data.notice;
          else {
            let keys = Object.keys(response.data.heads)
            currentObj.appended_column = [];
            keys.forEach((item, i) => {
              currentObj.appended_column.push(
                {
                  value: item,
                  text: item,
                  type: "text"
                }
              )
            })

            currentObj.employees = response.data.employee_data;
            currentObj.company_options = response.data.options;
            currentObj.list_key = this.list_key + 1;

            this.appendingActions();
          }
        }.bind(this)).catch(function (error) {
          currentObj.showOverlay = false;
          currentObj.serverError(error);
        });
    },
    appendingActions() {
      if (this.employees.length > 0) {
        this.employees.forEach((el, i) => {
          if (parseInt(el.employee_id) !== 0) {
            let actionArray = [];
            actionArray = actionArray.concat([
              { label: 'Edit', value: 1 },
            ]);
            el.actions = actionArray;
          }
        }); //end of for-each

        this.customEmployeeList = this.employees
      }
    },
    listReturn: function (data) {
      if (data.selected.length > 0) {
        this.selected = data.selected;
      } else {
        this.selected = [];
        if (data.employee_id > 0) {
          const employee = this.customEmployeeList.find(emp => emp.employee_id === data.employee_id); // Rejwan: 06-02-2025
          this.employee_name = employee.name; // Rejwan: 06-02-2025
          this.editEmployee(data.employee_id, 0);
        }
      }
    },
    editEmployee: function (em_id) {
      if (!this.checkNet()) return false;
      this.employeeID = em_id;
      // set employee here...
      // axios.post('employee/setemployee', formData).then((response) => {
      // $request->employee_id
      let currentObj = this;
      let formData = new FormData();
      formData.append('employee_id', em_id);
      axios.post(this.$api_url + '/employee/setemployee', formData)
        .then(function (response) {
          this.$bvModal.show('bv-modal-employee-cost-mapping');
        }.bind(this))
        .catch(function (error) {
          currentObj.serverError(error);
        });
    },
    exportCostSelected() {
      if (!this.checkNet()) return false;
      this.showOverlay = true;
      let currentObj = this;

      if (this.selected.length === 0) {
        this.$bvToast.toast("No Employee Selected", {
          title: `Error!`,
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-right'
        });
        return;
      }

      let formData = {
        employees: this.selected,
        year: this.current_year,
        type: this.type
      }

      const config = {
        headers: { 'Content-Type': 'application/json; charset=utf-8', },
        responseType: 'blob',
      }

      axios.post('export-cost-mapping', formData, config)
        .then(function (response) {
          currentObj.showOverlay = false;
          if (response.data.type === 'application/json') {
            let file = new Blob([response.data], { type: 'application/json' });
            /* if you use different error message just change the name instead of  'error_msg' */
            const cast = Promise.resolve(file.text());
            cast.then((value) => {
              let err_obj = JSON.parse(`${value}`);
              this.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
            });
          } else {
            this.global_download_file_content(response);
          }
        }.bind(this)).catch(function (error) {
          currentObj.showOverlay = false;
          currentObj.serverError(error);
        });
    },
    importData() {
      if (!this.checkNet()) return false;
      this.showOverlay = true;
      let currentObj = this; 

      if (!this.file) {
        let message = "Please select a file before uploading.";
        this.$bvToast.toast(message, {
          title: `Error`,
          variant: 'danger',
          solid: true
        });

        return;
      }

      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('type', this.type);
      const headers = { 'Content-Type': 'multipart/form-data' };

      axios.post('import-cost-mapping', formData, { headers })
        .then(function (response) {
          this.$bvModal.hide("bv-modal-file-upload");
          this.$emit('refresh-list', "");
          if (response.data?.errors) {
            this.$bvToast.toast(response.data?.errors[0], {
              title: `Error!`,
              variant: 'danger',
              solid: true,
              toaster: 'b-toaster-top-right'
            });
          } else {
            this.$bvToast.toast('Saved!', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
          }
          currentObj.showOverlay = false;
          this.refreshList();
        }.bind(this)).catch(function (error) {
          currentObj.showOverlay = false;
          currentObj.serverError(error);
        });
    },
    uploadFile() {
      this.file = this.$refs.file.files[0];
    },
    openUploadModal() {
      this.$bvModal.show("bv-modal-file-upload")
    },
    openOverheadUploadModal() {
      this.$bvModal.show("bv-modal-overhead-file-upload")
    },
    closeCostMappingModal() {
      // alert('here');
      this.$bvModal.hide('bv-modal-employee-cost-mapping');
      this.getEmployees();
      this.$bvToast.toast('Saved!', {
        title: `Success`,
        variant: 'success',
        solid: true
      });
    },
    downloadSelected: function () {
      if (this.selected.length == 0) {
        this.$bvToast.toast('No Employee selected.', {
          title: `Warning`,
          variant: 'warning',
          solid: true
        });

        return false;
      }

      if (!this.checkNet()) return false;
      let currentObj = this;

      let url = '';
      url = this.$api_url + '/ctc/file';

      this.$bvToast.toast('It might take a while', {
        title: `Info`,
        variant: 'info',
        solid: true
      });

      let formData = {
        employee_ids: this.selected,
        year: this.current_year,
        type: this.type
      };

      axios.post(url, formData)
        .then(function (response) {

          this.downloadFileContent(response.data);

        }.bind(this)).catch(function (error) { currentObj.serverError(error); });
    },
    mailSelected: function () {
      if (this.selected.length == 0) {
        this.$bvToast.toast('No Employee selected.', {
          title: `Warning`,
          variant: 'warning',
          solid: true
        });

        return false;
      }else if(this.selected.length > 100){
          alert("You are not allowed to send more than 100 emails in one go!");
          return false;
      }

      if (!this.checkNet()) return false;
      var msg = "Do you want to Email the selected Compensation Report(s)?";
      let currentObj = this;

      if(confirm(msg)){
        let url = '';
        url = this.$api_url + '/ctc/file';

        this.$bvToast.toast('It might take a while', {
          title: `Info`,
          variant: 'info',
          solid: true
        });

        let formData = {
          employee_ids: this.selected,
          year: this.current_year,
          type: this.type,
          email: 1,
        };

        axios.post(url, formData)
          .then(function (response) {

            this.$bvToast.toast('Email sent.', {
              title: `Success`,
              variant: 'success',
              solid: true
            });

          }.bind(this)).catch(function (error) { currentObj.serverError(error); });
      }
    },
  },
  created() {
    this.getEmployees();
  }
}
</script>
